<template>
  <div class="nx-form-hierarchical-textarea-wrapper mb-4"
       :data-vv-name="name"
       :data-vv-scope="scope"
       :data-vv-as="label"
       :error-messages="errorMessages"
       :name="name"
       :ref="name"
       :value="value"
       @input="onInput($event)"
       data-vv-value-path="value"
       v-validate="validation"
       data-vv-validate-on="input|blur"
  >
    <v-card flat color="primary lighten-4" >
      <v-card-title class="pb-0">
        <div class="subheading nx-text--level-1">{{ label }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="openEditor" color="text--secondary">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-1 pb-1 nx-text--level-1">
        <v-textarea
          readonly
          :value="textareaValue"
          :label="textareaLabel"
          @click="openEditor"
          box class="mt-2"
        ></v-textarea>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showEditor" width="600" lazy>
      <v-card>
        <v-card-title>
          <span>{{ label }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeEditor">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="draftValue"
            :label="translations.fieldValue"
            :required="required"
            :disabled="disabled"
            v-bind="$attrs"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" small flat @click="closeEditor">Cancelar</v-btn>
          <v-btn color="secondary" small flat @click="applyDraftValue">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';

export default {
  name: 'nx-form-hierarchical-textarea',
  mixins: [FormElement],
  props: {
    value: {
      type: Object,
      validator: (value) => {
        if (value === null) return true;
        if (!('value' in value)) return false;
        if ('inheritedValue' in value) {
          if (typeof value.inheritedValue !== 'object'
            || !('value' in value.inheritedValue)
            || !('origin' in value.inheritedValue)) {
            return false;
          }
        }
        return true;
      },
    },
  },
  data() {
    return {
      showEditor: false,
      draftValue: '',
    };
  },
  computed: {
    translations() {
      return {
        fieldValue: this.$t('message.form.hierarchical.fieldValue'),
        origin: (e, n) => this.$t('message.form.hierarchical.origin', { entity: this.$te(`message.entity.type.${e}`) ? this.$t(`message.entity.type.${e}`) : '', name: n }),
      };
    },
    fieldValue() {
      if (this.value && 'value' in this.value) {
        return this.value.value;
      }
      return '';
    },
    inheritedValueDef() {
      if (this.value && 'inheritedValue' in this.value) {
        return this.value.inheritedValue;
      }
      return {};
    },
    inheritedValue() {
      return this.inheritedValueDef.value || null;
    },
    inheritedFromOrigin() {
      return this.inheritedValueDef.origin || null;
    },
    textareaLabel() {
      if (this.fieldValue) return this.translations.fieldValue;
      if (this.inheritedFromOrigin) {
        return this.translations.origin(this.inheritedFromOrigin.type, this.inheritedFromOrigin.name);
      }
      return this.label;
    },
    textareaValue() {
      if (this.fieldValue) return this.fieldValue;
      if (this.inheritedValue) return this.inheritedValue;
      return '';
    },
  },
  watch: {},
  methods: {
    openEditor() {
      this.draftValue = this.textareaValue;
      this.showEditor = true;
      this.flags.focus = true;
    },
    closeEditor() {
      this.showEditor = false;
      this.flags.focus = false;
    },
    applyDraftValue() {
      const value = {
        inheritedValue: this.inheritedValueDef,
        value: this.draftValue,
      };
      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value);
      this.closeEditor();
    },
  },
  beforeCreate() {
  },
  mounted() {
  },
};
</script>
